import {NavigableIndicatorChart} from "./NavigableIndicatorChart";
import * as $ from "jquery";
import {formatDate} from "../../common/time/TimeCalculator";
import {formatNumber, prefixUrl} from "../../common/util";

/**
 * A navigable indicator chart that has a map image
 * @abstract
 * @extends NavigableIndicatorChart
 * @hideconstructor
 */
class MapImgNavigatableIndicatorChart extends NavigableIndicatorChart {

    getClassName() {
        return "MapImgNavigatableIndicatorChart";
    }

    _getSimpleStatsShower(data) {
        return undefined;
    }

    /**
     *
     * @param until {Date} The date until when to show data
     * @param wgs84Coords {Array<number>} 2 position array with coords lon lat in wgs84
     * @param mapImgUrls {string} The URL for the map image
     * @param dataFromService {Object} The data for the chart
     * @param regionArea {number} The area of the chart region (m2)
     */
    setChartParams(until, wgs84Coords, mapImgUrls, dataFromService, regionArea) {
        this.mapImgUrl = mapImgUrls
            ? Object.keys(mapImgUrls).filter(k => this.layer.getCode().toLowerCase().indexOf(k.toLowerCase()) >= 0 || k.toLowerCase().indexOf(this.layer.getCode().toLowerCase()) >= 0).map(k => mapImgUrls[k])[0]
            : undefined;

        super.setUntilAndCoords(until, wgs84Coords, false);
        this.regionArea = regionArea;

        if (dataFromService) {
            this.chartData = this._extractChartData(dataFromService);
            this._updateChart();
        }
        const imgContainer = $('.map-img-container', this.getUIElement());
        if (this.mapImgUrl) {
            $('img.map-img', imgContainer).attr('src', prefixUrl(this.mapImgUrl));
            imgContainer.show();
        } else {
            imgContainer.hide();
        }
    }

    _updateChart() {
        if (this.chartData) {
            super._updateChart();
            const refDate = formatDate(this.layer.getTimeCalculator().fixDate(this.originalUntil));
            const element = this.chartData[refDate];
            const affected = {};
            if (element) {
                Object.keys(element).forEach(a => affected[a] = {
                    area: element[a]/100 * this.regionArea,
                    part: element[a]
                });
            }

            const untilStr = formatDate(this.layer.getTimeCalculator().fixDate(this.originalUntil));
            const timeStr = this.translator.translate('tool.charts.stats.title', [this.layer.getTimeCalculator().timeCodeToString(untilStr).toLowerCase()]);

            const table = $(
                '<div class="stats">' +
                '   <table class="values">' +
                '      <thead><tr><th>' + timeStr + '</th><th>' + this.translator.translate('tool.charts.stats.area') + '</th><th>' + this.translator.translate('tool.charts.stats.perc') + '</th></tr></thead>' +
                '      <tbody></tbody>' +
                '   </table>' +
                '</div>'
            );
            const timeseriesProcessor = this.layer.getTimeseriesProcessor(this.chartData);
            Object.keys(affected).forEach(clazz => {
                const value = timeseriesProcessor.getClassToValue(clazz);
                const label = this.layer.getChartStyler().getLabelFunction()(value);
                const color = this.layer.getChartStyler().getColorFunction()(value);
                $('tbody', table).append(
                    $('<tr><td><div class="color" style="background-color: ' + color + '"></div><label>' + label + '</label></td><td class="value">' + formatNumber(affected[clazz].area / 1000000, 2) + '</td><td class="value">' + formatNumber(affected[clazz].part, 2) + '</td></tr>')
                );
            });

            const partDiff = 100-Object.keys(affected).map(a => affected[a].part).reduce((p, c) => p + c, 0);
            $('tbody', table).append(
                $('<tr><td><label>' + this.translator.translate('tool.charts.stats.noData') + '</label></td><td class="value">' + formatNumber(this.regionArea * (partDiff/100) / 1000000, 2) + '</td><td class="value">' + formatNumber(partDiff, 2) + '</td></tr>')
            );

            $('tbody', table).append(
                $('<tr><td><label>' + this.translator.translate('tool.charts.stats.wholeReportingUnit') + '</label></td><td class="value">' + formatNumber(this.regionArea / 1000000, 2) + '</td><td></td></tr>')
            );

            $('.stats-container', this.getUIElement()).empty().append(table);
        }
    }

    _calcBarWidth(x) {
        const width = super._calcBarWidth(x);
        return width.slice(0, width.length - 1);
    }

    getContainerElement() {
        const containerElement = super.getContainerElement();
        containerElement.addClass('map-img-chart');
        $('.date-picker-chart-container', containerElement).removeClass('date-picker-chart-container');
        const statsAndChart = $('<div class="stats-chart-container"></div>');
        const stats = $('<div class="stats-container"></div>');
        statsAndChart.append(stats);
        const chartContainer = $('.chart-container', containerElement);
        chartContainer.addClass('date-picker-chart-container');
        containerElement.remove('.chart-container');
        statsAndChart.append(chartContainer);

        const img = $('<div class="map-img-container"><img alt="'+this.layer.getName()+' map image" class="map-img"/></div>');
        $('.body', containerElement).prepend(statsAndChart).prepend(img);
        if (!this.mapImgUrl)
            img.hide();
        else $('img',img).attr('src',this.mapImgUrl);

        return containerElement;
    }
}

export {MapImgNavigatableIndicatorChart}